// Integrations — per-location integrations. Currently Google Calendar only.
// Intentionally shown only in location / merged modes.
import React from 'react';

const IntegrationsTab = ({ locationData, location, onConnectCalendar, onDisconnectCalendar }) => {
  const locData = location ? (locationData[location.location_id] || {}) : {};
  const isCalConnected = locData.isCalendarConnected;
  const calLoading = locData.calendarLoading;

  return (
    <>
      {/* Google Calendar */}
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-calendar mr-2"></i>
            Google Calendar
          </h4>
          {location && (
            <div>
              {isCalConnected ? (
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => onDisconnectCalendar(location.location_id)}
                  disabled={calLoading}
                >
                  {calLoading ? 'Disconnecting...' : 'Disconnect'}
                </button>
              ) : (
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => onConnectCalendar(location.location_id)}
                  disabled={calLoading}
                >
                  {calLoading ? 'Connecting...' : 'Connect'}
                </button>
              )}
            </div>
          )}
        </div>
        <div className="card-body">
          {!location ? (
            <p className="text-muted mb-0">No location available.</p>
          ) : isCalConnected ? (
            <>
              <span className="badge badge-success mr-2">
                <i className="fa-sharp fa-regular fa-check mr-1"></i> Connected
              </span>
              <span className="text-muted">Jobs sync to your Google Calendar</span>
            </>
          ) : (
            <>
              <span className="badge badge-secondary mr-2">Not Connected</span>
              <span className="text-muted">Connect to sync jobs to Google Calendar</span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default IntegrationsTab;
